module.exports = __webpack_public_path__ + "01_short_brown.f8d856fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_short_brown.png
// module id = AbGi
// module chunks = 0